// src/errors.ts
var ErrorCodes = {
  DOCUMENT_EXPIRED: 4500,
  DOCUMENT_INVALID: 4501
};
var DocumentExpiredError = class extends Error {
  constructor(reason = "Document Expired") {
    super(reason);
    this.name = "DocumentExpiredError";
    this.reason = reason;
    this.code = ErrorCodes.DOCUMENT_EXPIRED;
  }
};
var DocumentInvalidError = class extends Error {
  constructor(reason = "Document Invalid") {
    super(reason);
    this.name = "DocumentInvalidError";
    this.reason = reason;
    this.code = ErrorCodes.DOCUMENT_INVALID;
  }
};

// src/metadata.ts
import { getProxy } from "@ballpark/realtime-crdt";
var METADATA_KEY = "__meta";
function getMetadata(doc, key) {
  const metadata = doc.getMap(METADATA_KEY);
  if (key === void 0)
    return metadata;
  return metadata.get(key);
}
function setMetadata(doc, key, value) {
  const metadata = doc.getMap(METADATA_KEY);
  if (metadata.get(key) === value)
    return;
  metadata.set(key, value);
}
function getProxiedMetadata(doc) {
  return getProxy(getMetadata(doc));
}
function getGeneration(doc) {
  return getMetadata(doc, "generation") || 0;
}
function setGeneration(doc, generation) {
  return setMetadata(doc, "generation", generation);
}
export {
  DocumentExpiredError,
  DocumentInvalidError,
  ErrorCodes,
  METADATA_KEY,
  getGeneration,
  getMetadata,
  getProxiedMetadata,
  setGeneration,
  setMetadata
};
